export const siteInfo = {
  name: '问鼎下载',
  tagline: '官方正版安全下载平台',
  description: '问鼎下载是您获取正版软件、游戏及应用的首选平台。提供快速、安全、免费的下载服务，海量资源一键获取，支持多平台设备。',
  keywords: '问鼎下载,问鼎下载官网,问鼎软件下载,问鼎游戏下载,问鼎app下载,问鼎安装包下载,问鼎最新版下载',
  url: 'https://qianchenga.cn',
  logo: '问鼎下载',
  email: 'contact@wendingxiazai.com',
  phone: '400-888-6666',
  address: '北京市海淀区中关村软件园',
  icp: '京ICP备2024XXXXXXXX号',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '软件', href: '/category/software' },
  { label: '游戏', href: '/category/games' },
  { label: '应用', href: '/category/apps' },
  { label: '文章', href: '/category/articles' },
  { label: '关于我们', href: '/about' },
];

export const stats = [
  { label: '累计下载', value: '12.8亿+', icon: 'ri-download-cloud-2-line' },
  { label: '正版资源', value: '50万+', icon: 'ri-shield-check-line' },
  { label: '活跃用户', value: '3800万+', icon: 'ri-user-smile-line' },
  { label: '安全认证', value: '100%', icon: 'ri-verified-badge-line' },
];

export const features = [
  { title: '正版保障', desc: '所有资源均通过正版授权认证，杜绝病毒和恶意插件，确保下载安全无忧。', icon: 'ri-shield-star-line' },
  { title: '极速下载', desc: '采用CDN加速与P2P传输技术，多线程并发下载，大文件也能飞速完成。', icon: 'ri-speed-up-line' },
  { title: '海量资源', desc: '涵盖办公软件、设计工具、热门游戏、实用应用等数十万款正版资源。', icon: 'ri-database-2-line' },
  { title: '一键安装', desc: '智能识别系统环境，自动匹配最佳版本，全程静默安装，无需繁琐配置。', icon: 'ri-install-line' },
  { title: '实时更新', desc: '第一时间推送软件最新版本，自动检测并提醒更新，永不错过重要功能。', icon: 'ri-refresh-line' },
  { title: '多端支持', desc: '全面支持Windows、macOS、Android、iOS等主流平台，跨设备无缝体验。', icon: 'ri-device-line' },
];